module.exports = __webpack_public_path__ + "site/img/31.cdc7866c.jpg";